define('modules/common/directive/AppMenu',[], function() {
    var Directive = function(DatiCliente, Studio, RiferimentiStudio, $modal) {

        return {
            restrict: 'E',
            /*scope: {

            },*/
            replace: true,
            templateUrl: 'modules/common/view/appmenu.tpl.html',
            controller: ["$scope", "$state", function($scope, $state) {

                $scope.onEnter = function() {
                    $state.go('fascicoli', {
                        'aliasStudio': $scope.aliasStudio,
                        'query': $scope.queryFascicoliMenu
                    });
                };

                $scope.canChangePassword = false;
                DatiCliente.canChangePassword().then(function(canChangePassword){
                    $scope.canChangePassword = canChangePassword
                });

                var chPassModal = {
                    animation: true,
                    templateUrl: 'modules/common/view/modalChangePassword.tpl.html',
                    controller: 'ModalChangePasswordController',
                    size: "md"
                };
                $scope.changePassword = function($event) {
                    chPassModal.backdrop = true;
                    $modal.open(chPassModal);
                    $event.stopPropagation();
                };

                $scope.aliasStudio = Studio.getAlias();
                DatiCliente.getDenominazione().then(function(denominazione) {
                    $scope.denominazione = denominazione;
                });
                RiferimentiStudio.getDati().then(function(riferimentiStudio) {
                    $scope.intestazionePrincipale = riferimentiStudio.intestazioneprincipale;
                    $scope.intestazioneSecondaria = riferimentiStudio.intestazionesecondaria;
                    RiferimentiStudio.hasLogo().then(function(logoExists) {
                        if (logoExists) {
                            RiferimentiStudio.getLogo().then(function(logo) {
                                $scope.urlLogo = logo;
                            });
                        } else {
                            $scope.urlLogo = "";
                        }
                    });
                });
            }],
            link: ["$scope", "element", "attrs", function($scope, element, attrs) {

            }]
        };

    };
    return ["DatiCliente", "Studio", "RiferimentiStudio", "$modal", Directive];
});
